<template>
	<v-col cols="10" class="flex-none mx-auto">
		<div class="inventory-items">
			<p class="inventory-items-title">Sub-Items: {{ item.styleCode }}</p>
			<div class="flex-table" role="table-head">
				<div class="flex-table-row" role="row-group">
					<div class="flex-table-cell" role="column-header">&nbsp;</div>
					<div class="flex-table-cell" role="column-header">Style Code</div>
					<div class="flex-table-cell" role="column-header">Description</div>
					<div class="flex-table-cell" role="column-header">Quantity</div>
					<div class="flex-table-cell" role="column-header">Default</div>
					<div class="flex-table-cell" role="column-header">Price Included</div>
					<div class="flex-table-cell" role="column-header">&nbsp;</div>
				</div>
			</div>
			<div class="flex-table" role="table-body">
				<v-form ref="form" v-model="valid" lazy-validation>
					<div
						v-for="sub in subItems"
						:key="sub.id"
						class="flex-table-row"
						:class="sub.itemData.systemCategoryId == 16 ? 'flex-table-row-2' : null"
						role="row-group"
					>
						<div class="flex-table-cell" role="cell">{{ sub.id + 1 }}</div>
						<div class="flex-table-cell" role="cell">
							<SystemCategoryIcon :system-category-id="sub.itemData.systemCategoryId" />
							<div class="form-input search-input">
								<v-combobox
									prepend-inner-icon="mdi-magnify"
									dense
									outlined
									placeholder="Search Style Codes"
									hide-details="auto"
									:value="sub"
									:items="searchResults"
									:item-text="renderStyleCode"
									@change="($event) => updateSubItem($event, sub.id)"
									@keyup="searchSubItems($event.srcElement.value)"
									:disabled="!canManageInventory"
								>
									<template v-slot:item="{ item, attrs, on }">
										<v-list-item v-on="on" v-bind="attrs">
											<v-list-item-content>
												<v-list-item-title>
													<v-row no-gutters align="center">
														<SystemCategoryIcon :system-category-id="item.systemCategoryId" />
														{{ `${item.itemData.styleCode} - ${item.itemData.description}` }}
													</v-row>
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-combobox>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<div class="form-input">
								<v-text-field
									outlined
									dense
									hide-details="auto"
									v-model="sub.itemData.description"
									disabled
								></v-text-field>

								<v-text-field
									v-if="sub.itemData.systemCategoryId == 16"
									outlined
									dense
									hide-details="auto"
									v-model="sub.braidPosition"
									placeholder="Braid Position"
									class="mt-2"
									:disabled="!canManageInventory"
								></v-text-field>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<div class="form-input">
								<v-text-field
									class="number-input"
									outlined
									dense
									hide-details="auto"
									v-model="sub.quantity"
									type="number"
									min="0"
									:disabled="!canManageInventory"
								></v-text-field>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<div class="form-input">
								<v-select
									v-model="sub.isDefault"
									:items="[
										{ text: 'Yes', value: true },
										{ text: 'No', value: false },
									]"
									item-text="text"
									item-value="value"
									dense
									outlined
									hide-details="auto"
									:disabled="!canManageInventory"
								></v-select>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<div class="form-input">
								<v-select
									v-model="sub.priceIncluded"
									:items="[
										{ text: 'Yes', value: true },
										{ text: 'No', value: false },
									]"
									item-text="text"
									item-value="value"
									dense
									outlined
									hide-details="auto"
									:disabled="!canManageInventory"
								></v-select>
							</div>
						</div>
						<div class="flex-table-cell" role="cell">
							<v-btn :disabled="!canManageInventory" icon @click="removeSubItem(sub)"
								><v-icon>mdi-close</v-icon></v-btn
							>
						</div>
					</div>
					<div class="inventory-items-action">
						<v-btn v-if="canManageInventory" plain color="accent" @click="addSubItem()">
							<v-icon>mdi-plus</v-icon>
							Add Another Item
						</v-btn>
					</div>
				</v-form>
			</div>
		</div>
	</v-col>
</template>

<script>
import gql from "graphql-tag";
import SystemCategoryIcon from "@/components/SystemCategoryIcon.vue";
export default {
	name: "InventoryItemSubItemView",
	props: {
		item: {
			type: Object,
		},
		canManageInventory: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			itemData: {
				subItems: [],
			},
			showSearchByIndex: null,
			searchResults: [],
			valid: true,
			subItems: [],
		};
	},
	methods: {
		renderStyleCode(event) {
			if (event.itemData) {
				return event.itemData.styleCode;
			}
		},
		addSubItem() {
			const lastId =
				this.itemData.subItems.length > 0
					? this.itemData.subItems[this.itemData.subItems.length - 1].id
					: -1;

			const newSubItem = {
				id: lastId + 1,
				itemData: {
					systemCategoryId: null,
					styleCode: "",
					description: "",
				},
				quantity: null,
				isDefault: null,
				priceIncluded: null,
			};
			this.itemData.subItems.push(newSubItem);
			this.subItems.push(newSubItem);
		},
		removeSubItem(item) {
			//filter out the passed in item
			this.itemData.subItems = this.itemData.subItems.filter((obj) => obj.id !== item.id);
			this.subItems = this.subItems.filter((obj) => obj.id !== item.id);
		},
		async searchSubItems(searchTerm) {
			try {
				//send gql query to get current sub items and filter by the searched terms in itemData.styleCode
				const res = await this.$apollo.query({
					query: gql`
						query GetSubItems($searchTerm: String!) {
							inventoryListings(
								order: { systemCategoryId: ASC }
								where: { type: { eq: "subItem" }, styleCode: { contains: $searchTerm } }
							) {
								items {
									inventoryItemId
									systemCategoryId
									styleCode
									description
								}
								pageInfo {
									hasNextPage
									hasPreviousPage
								}
							}
							subItemCategories(
								order: { systemCategoryId: ASC }
								where: { name: { contains: $searchTerm } }
							) {
								items {
									subItemCategoryId
									systemCategoryId
									styleCode: name
									description
								}
								pageInfo {
									hasNextPage
									hasPreviousPage
								}
							}
						}
					`,
					variables: {
						searchTerm: searchTerm,
					},
					fetchPolicy: "no-cache",
				});
				//replace with res.data once api is setup
				console.log(`searching for sub items with ${searchTerm}`, [
					...res.data.inventoryListings.items,
					...res.data.subItemCategories.items,
				]);
				//change the returned gql data structure to work with rendering format
				this.searchResults = [
					...res.data.subItemCategories.items,
					...res.data.inventoryListings.items,
				].map((obj) => {
					return {
						...obj,
						itemData: {
							systemCategoryId: obj.systemCategoryId,
							styleCode: obj.styleCode,
							description: obj.description,
						},
					};
				});
			} catch (error) {
				console.log(error);
			}
		},
		updateSubItem(value, id) {
			// A row is EITHER a concrete sub-item (inventoryItemId) OR a category
			// (subItemCategoryId). Object.assign never clears keys, so switching kinds would
			// leave the stale opposite key set and the row would save as the wrong kind.
			const normalized = { ...value };
			if (normalized.subItemCategoryId) {
				normalized.inventoryItemId = null;
			} else if (normalized.inventoryItemId) {
				normalized.subItemCategoryId = null;
			}

			const subItemToUpdate = this.itemData.subItems.find((subItem) => subItem.id === id);
			if (subItemToUpdate) {
				Object.assign(subItemToUpdate, normalized); // Update properties of the existing object
				subItemToUpdate.id = id; // Ensure that the id property is maintained
			}

			const toUpdate = this.subItems.find((subItem) => subItem.id === id);
			if (toUpdate) {
				Object.assign(toUpdate, normalized); // Update properties of the existing object
				toUpdate.id = id; // Ensure that the id property is maintained
			}
		},
	},
	async mounted() {
		// tee-up search results
		await this.searchSubItems("");
	},
	computed: {
		storeItem() {
			return this.$store.getters.inventoryItem;
		},
	},
	beforeDestroy() {
		//push current item data to state
		this.$store.dispatch("updateInventoryItem", this.itemData);
		//let parent component know data has been updated in state
		this.$emit("updated");
	},
	watch: {
		// Re-adopt the store object whenever the parent view's async fetch
		// replaces it — children mount before the parent's mounted() completes,
		// so a one-shot read here can capture a stale tree and orphan edits.
		storeItem: {
			immediate: true,
			handler(item) {
				this.itemData = item;
				(this.itemData.subItems || []).forEach((subItem, index) => {
					subItem.id = index;
				});
				this.subItems = (this.itemData.subItems || []).map((subitem) => ({ ...subitem }));
			},
		},
		subItems: {
			deep: true,
			handler() {
				this.itemData.subItems = this.subItems.map((subitem) => ({ ...subitem }));
			},
		},
	},
	components: { SystemCategoryIcon },
};
</script>

<style lang="scss" scoped>
.inventory {
	&-form {
		width: 50rem;
		margin: 0 auto;

		.form-radio {
			justify-content: center;
		}
	}

	&-items {
		position: relative;

		&-title {
			font-size: 1.4rem;
		}

		.flex-table[role="table-body"] {
			background-color: $color-white;
		}

		//braid specific row styling
		.flex-table-row-2 {
			align-items: flex-start;

			.flex-table-cell {
				&:nth-child(1) {
					margin-top: 2rem;
				}
				&:nth-child(7) {
					margin-top: 1.2rem;
				}
			}
		}

		.flex-table-cell {
			&:nth-child(1) {
				width: 3%;
				justify-content: center;
			}
			&:nth-child(2) {
				width: 27%;
			}
			&:nth-child(3) {
				width: 36%;
			}
			&:nth-child(4) {
				width: 10%;
			}
			&:nth-child(5) {
				width: 10%;
			}
			&:nth-child(6) {
				width: 10%;
			}
			&:nth-child(7) {
				width: 4%;
				justify-content: center;
			}
		}

		.form-input {
			width: 100%;
		}

		&-icon {
			display: inline-flex;
			justify-content: center;
			align-items: center;
			border: 1px solid $color-gray;
			border-radius: 5px;
			background-color: $color-gray;
			min-height: 5rem;
			min-width: 5rem;
			margin-right: 1rem;
		}

		&-action {
			display: block;
			padding: 0.8rem;
			border-top: 1px solid $color-gray;
		}
	}
}

.search-input {
	position: relative;

	&-dropdown {
		position: absolute;
		left: 0;
		bottom: -28.5rem; //height of the filter + extra spacing
		background-color: $color-white;
		border-radius: 3px;
		width: 40vw;
		max-width: 40vw;
		height: 28rem;
		box-shadow: rgba(50, 50, 93, 0.15) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
		z-index: 1000;
		overflow-y: auto;
		overflow-x: hidden;

		&-results {
			ul {
				list-style: none;
				padding-left: 0;

				li {
					display: flex;
					flex-flow: row wrap;
					align-items: center;
					font-size: 1.3rem;
					white-space: nowrap;
					transition: all 0.4s;
					padding: 0.8rem;
					padding-left: 1rem;

					&:hover {
						cursor: pointer;
						background-color: $color-gray-light;
					}

					&:not(:last-child) {
						border-bottom: 1px solid $color-gray;
					}

					h4,
					p {
						font-size: 1.4rem;
						font-weight: normal;
						text-transform: uppercase;
					}

					h4 {
						margin: 0 1.5rem 0 1rem;
					}
				}
			}
		}
	}
}
</style>
